/*
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions
 * and limitations under the License.
 */
import Logo from '../images/logo.png';
import BGImage from '../images/BGImage.jpg';
import { palette, typography } from './common';

const fgColour = palette.backgroundMain;
const bgColour = palette.foregroundMain;

export const Container = {
  fontFamily: typography.fontFamily,
};
export const FormContainer = {};
export const FormSection = {};
export const FormCard = {
  padding: '1.5rem',
  marginBottom: 0,
  minHeight: '100vh',
  boxShadow:
  '0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12)',
};
export const FormField = {
};

export const BackgroundImage = {
  backgroundSize: 'cover',
  backgroundImage: `url(${BGImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
};
export const LogoImage = {
  logo: Logo,
  marginTop: '1rem',
  marginBottom: '1rem',
  maxWidth: '120px',
};

export const SectionHeader = {
  textAlign: 'center',
  fontSize: '1rem',
};
export const SectionBody = {};
export const SectionFooter = {};
export const SectionFooterPrimaryContent = {
  marginBottom: '1rem',
};
export const SectionFooterSecondaryContent = {};
export const Input = {};
export const Button = {
  color:bgColour,
};
export const PhotoPickerButton = {};
export const PhotoPlaceholder = {};
export const SignInButton = {};
export const SignInButtonIcon = {};
export const SignInButtonContent = {};
export const Strike = {};
export const StrikeContent = {};
export const ActionRow = {};
export const FormRow = {};
export const SelectInput = {}
export const Select = {}
export const A = {
  backgroundColor: bgColour,
};
export const Hint = {};
export const Radio = {};
export const Label = {};
export const InputLabel = {
  color: fgColour,
};
export const AmazonSignInButton = {};
export const FacebookSignInButton = {};
export const GoogleSignInButton = {};
export const OAuthSignInButton = {};
export const Toast = {};
export const NavBar = {};
export const NavRight = {};
export const Nav = {};
export const NavItem = {};
export const NavButton = {};

const AmplifyTheme = {
  container: Container,
  formContainer: FormContainer,
  formSection: FormSection,
  formCard: FormCard,
  formField: FormField,

  backgroundImage: BackgroundImage,
  logoImage: LogoImage,

  sectionHeader: SectionHeader,
  sectionBody: SectionBody,
  sectionFooter: SectionFooter,
  sectionFooterPrimaryContent: SectionFooterPrimaryContent,
  sectionFooterSecondaryContent: SectionFooterSecondaryContent,

  input: Input,
  button: Button,
  photoPickerButton: PhotoPickerButton,
  photoPlaceholder: PhotoPlaceholder,
  select: Select,
  selectInput: SelectInput,
  signInButton: SignInButton,
  signInButtonIcon: SignInButtonIcon,
  signInButtonContent: SignInButtonContent,
  amazonSignInButton: AmazonSignInButton,
  facebookSignInButton: FacebookSignInButton,
  googleSignInButton: GoogleSignInButton,
  oAuthSignInButton: OAuthSignInButton,

  formRow: FormRow,
  strike: Strike,
  strikeContent: StrikeContent,
  actionRow: ActionRow,
  a: A,

  hint: Hint,
  radio: Radio,
  label: Label,
  inputLabel: InputLabel,
  toast: Toast,

  navBar: NavBar,
  nav: Nav,
  navRight: NavRight,
  navItem: NavItem,
  navButton: NavButton,
};

export default AmplifyTheme;
